'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import WearableappServices from '@/components/technologies/wearableapp-services';
import YiiModelsOfWorking from '@/components/technologies/yii-models-of-working';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Build Smart, Interactive and Meaningful Wearable App Development for iWatch & Android Wear"
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'wearable-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Wearable App Development
            </TechHeroApp>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Wearable App Development" />
            <ContetVideoSection title="Smart Wearable Application Development to Take Hold In The Ever-Demanding & Innovative Market">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Are you really focused to meet latest technology trends and changing market demands?
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        If it’s a YES, we’re here to enhance your business with engaging, productive yet scalable wearable app
                        development services that satisfies all your business and enterprise purposes.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb offers best blend of cutting-edge and scalable wearable app development services that will surely
                        help you gain advantage over your competitors. Be it medical, entertainment, fitness, lifestyle, utility
                        or gaming applications, our wearable app development team delivers top-notch applications that hits the
                        market and meets all your expectations.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Being a leading wearable app development company, we have expanded multiple domains and have served more
                        than 500 clients globally. So, whether it’s Apple or Android app development, we build the BEST.
                    </p>
                </>
            </ContetVideoSection>
            <WearableappServices></WearableappServices>
            <HireProcess
                bg="bg-wearable"
                pageTitle="Hire Custom Wearable App Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using DevOps."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Wearable App Development?" />

            <YiiModelsOfWorking
                title="Engagement models to hire the best Wearable App Developers"
                desc="Select from different engagement models to hire Wearable App Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />

            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
